module.exports = __webpack_public_path__ + "static/media/windChime1.5685664d.mp3";